// Canonical call states for Voice
export const CALL_STATES = {
  IDLE: "idle",
  RINGING: "ringing",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  FAILED: "failed",
};
